import { render, staticRenderFns } from "./FlashcardEditor.vue?vue&type=template&id=97d46cf8&scoped=true&"
import script from "./FlashcardEditor.vue?vue&type=script&lang=js&"
export * from "./FlashcardEditor.vue?vue&type=script&lang=js&"
import style0 from "./FlashcardEditor.vue?vue&type=style&index=0&id=97d46cf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d46cf8",
  null
  
)

export default component.exports